'use client';

import type { Dialog } from '@base-ui/react/dialog';
import { useElementInteracted } from '@repo/platform-analytics/hooks/useElementInteracted';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import { getOrCreateId } from '@repo/platform-utils/static-ids';
import { useRef } from 'react';
import type { BranchId } from '@/shared/config/funnel/constants';
import { ANALYTICS_ACTION_NAME, ANALYTICS_EXIT_INTENT_ACTION_SECTION } from './constants';
type DialogCloseReason = Dialog.Root.ChangeEventReason;
const DISMISS_REASONS: DialogCloseReason[] = ['outside-press', 'escape-key'];
export function useExitModalCloseAction(branchId: BranchId | null) {
  const activityIdRef = useRef('');
  const featureViewedActivityId = getOrCreateId(activityIdRef);
  const firePageAction = usePageAction({
    actionName: ANALYTICS_ACTION_NAME,
    actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
    actionType: 'close',
    actionInput: 'exit',
    parentActivityId: featureViewedActivityId,
    pageBranchName: branchId
  });
  const fireElementInteracted = useElementInteracted({
    entityName: ANALYTICS_ACTION_NAME,
    sectionName: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
    interactionType: 'close',
    parentEventId: featureViewedActivityId,
    additionalAttributes: branchId ? {
      page_branch_name: branchId
    } : undefined
  });
  const fireCloseAction = (reason?: DialogCloseReason) => {
    firePageAction();
    if (reason && DISMISS_REASONS.includes(reason)) {
      fireElementInteracted();
    }
  };
  return {
    featureViewedActivityId,
    fireCloseAction,
    fireDismissInteraction: () => fireElementInteracted()
  };
}